export default {
    notifications: null,
};
